var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow15093084(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLYPH"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.52 129.86c-13.44-49.48-64.89-100.94-114.37-114.37-30.34-7.57-70.98-15.36-126.15-15.49-55.17.14-95.81 7.92-126.15 15.49-49.47 13.44-100.93 64.89-114.37 114.37-7.56 30.33-15.35 70.98-15.48 126.14.13 55.17 7.92 95.82 15.48 126.15 13.44 49.48 64.9 100.93 114.37 114.37 30.34 7.57 71 15.35 126.15 15.49 55.16-.14 95.81-7.92 126.15-15.49 49.48-13.44 100.93-64.89 114.37-114.37 7.56-30.33 15.35-71 15.48-126.15-.13-55.16-7.92-95.81-15.48-126.14zm-118 180.5-110.92 110.92a16.39 16.39 0 0 1 -23.19 0l-110.9-110.92a16 16 0 0 1 22.56-22.56l84 84v-269.94a15.95 15.95 0 0 1 31.9 0v269.91l84-84a16 16 0 0 1 22.56 22.56z",
    fill: "rgba(0, 0, 0, .75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow15093084);
export default __webpack_public_path__ + "static/media/down-arrow_15093084.ea82ee2f4941aef29b7057746d6f9562.svg";
export { ForwardRef as ReactComponent };